function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTxWindFuture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 102.14 101.95",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M81.81,77H41.47a2.5,2.5,0,1,0,0,5H81.81a7.48,7.48,0,1,1-7.47,7.48,9.31,9.31,0,0,1,.21-1.95,2.49,2.49,0,0,0-.34-1.88,2.46,2.46,0,0,0-1.57-1.09,2.54,2.54,0,0,0-3,1.91,14.83,14.83,0,0,0-.33,3A12.47,12.47,0,1,0,81.81,77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M57.7,86.78H34.36a2.5,2.5,0,0,0,0,5H57.7a2.18,2.18,0,1,1-2,2.9,2.55,2.55,0,0,0-3.19-1.52A2.5,2.5,0,0,0,51,96.34a7.17,7.17,0,1,0,6.75-9.56Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.42,72H76.89A10.32,10.32,0,1,0,66.57,61.65a2.5,2.5,0,0,0,5,0A5.33,5.33,0,1,1,76.89,67H49.42a2.5,2.5,0,0,0,0,5Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M100.94,30.62a3,3,0,0,0-4.2.6l-5.31,7-3.16.36-6.88-5.2a3,3,0,0,0-4,4.44,4.4,4.4,0,0,0,.39.35l10.86,8.16a3.06,3.06,0,0,0,1.37.74h0a3.4,3.4,0,0,0,.46.06h.39l.12,0a2.93,2.93,0,0,0,.41-.07l.11,0A3,3,0,0,0,93.15,46l8.39-11.16A3,3,0,0,0,100.94,30.62Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.67,8.46a3,3,0,0,1-2.1-5.62c1-.37,2-.71,3-1h0c1.27-.37,2.58-.7,3.88-1a3,3,0,1,1,1.2,5.88c-1.13.23-2.27.52-3.38.85C34.43,7.84,33.54,8.14,32.67,8.46Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5,14a42.71,42.71,0,0,0-4.4,3.79,3,3,0,0,1-4.22-4.26,47.26,47.26,0,0,1,5-4.34A3,3,0,1,1,22.5,14Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.87,34.21A2.86,2.86,0,0,1,4.8,34a3,3,0,0,1-1.74-3.87,47.11,47.11,0,0,1,2.81-6A3,3,0,0,1,11.12,27a41.15,41.15,0,0,0-2.45,5.26A3,3,0,0,1,5.87,34.21Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.13,43.41a3,3,0,1,1,6,.44C6,44.93,6,46,6,47.14c0,.83,0,1.68.09,2.51a3,3,0,0,1-2.79,3.2H3.12a3,3,0,0,1-3-2.8C0,49.1,0,48.13,0,47.18,0,45.92,0,44.65.13,43.41Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4.73,59.48A3,3,0,0,1,8.6,61.24,40.31,40.31,0,0,0,11,66.51a3,3,0,0,1-1.19,4.07A2.81,2.81,0,0,1,8.43,71a3,3,0,0,1-2.68-1.56,46.5,46.5,0,0,1-2.77-6A3,3,0,0,1,4.73,59.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.84,75.68c.65.66,1.34,1.31,2,1.92a3,3,0,0,1-3.19,5,3.08,3.08,0,0,1-.77-.5c-.8-.7-1.59-1.44-2.33-2.2a3,3,0,1,1,4.26-4.22Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.62,44.7l.35,0a3,3,0,0,0,2.63-3.33A46.92,46.92,0,0,0,50.19,0a3,3,0,1,0-.41,6A40.92,40.92,0,0,1,87.64,42.05,3,3,0,0,0,90.62,44.7Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43,45.77l2.54-22.58a1.49,1.49,0,0,1,2.94,0l2.8,22.54A4.27,4.27,0,0,1,47.14,51h0A4.26,4.26,0,0,1,43,45.77Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.56,50.3,26.64,73.59a1.57,1.57,0,0,1-2.35-2l19-26.68a4.27,4.27,0,0,1,6.59-1.3h0A4.26,4.26,0,0,1,49.56,50.3Z",
    style: {
      fill: "#fff"
    }
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTxWindFuture);
export default __webpack_public_path__ + "static/media/tx_WindFuture.919d6fc8bf5bc700c617c58e8e563a86.svg";
export { ForwardRef as ReactComponent };